export enum DraggableListDirection {
  horizontal = 'horizontal',
  vertical = 'vertical',
}

export type DraggableListDataItem = {
  id: string | number;
  name?: string;
};